// extracted by mini-css-extract-plugin
export default {"actions":"style_actions__Y3e2U","actions_btn":"style_actions_btn__3kfKc"};